import styled from "@emotion/styled";

import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
} from "@/mds";

interface CommercialPlanReviewModalProps {
  detail?: string;
  isOpen: boolean;
  onClose: () => void;
  onReviewPlans: () => void;
  plansAreAvailable?: boolean;
  title: string;
}

/**
 * Safe bridge from a legacy feature gate into the authoritative commercial
 * catalog. It never displays legacy prices or starts checkout directly.
 */
export const CommercialPlanReviewModal = ({
  detail,
  isOpen,
  onClose,
  onReviewPlans,
  plansAreAvailable = true,
  title,
}: CommercialPlanReviewModalProps) => (
  <MDSModalDialog isOpen={isOpen} handleClose={onClose}>
    <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
      {title}
    </MDSText>
    <ReviewDialogContent slot={MDSDialogSlotName.Content}>
      {detail ? <MDSText variant={MDSTextVariant.ParagraphS}>{detail}</MDSText> : null}
      <MDSText variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Secondary}>
        {plansAreAvailable
          ? "Review your current usage and compare the new Mem plans in Subscription Management."
          : "Review your current plan and usage in Subscription Management. Billing changes are temporarily unavailable."}
      </MDSText>
    </ReviewDialogContent>
    <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
      <MDSButton onClick={onClose}>Not now</MDSButton>
      <MDSButton variant={MDSButtonVariant.Emphasis} onClick={onReviewPlans}>
        {plansAreAvailable ? "Compare plans" : "Review subscription"}
      </MDSButton>
    </MDSButtonGroup>
  </MDSModalDialog>
);

const ReviewDialogContent = styled(MDSDialogTextContent)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
`;
